"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastActions = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _spacing = require("../../../constants/spacing");
/**
 * @deprecated please use @smartsheet/sds-toast-state-service instead. See
 * https://webappassets.dev.smar.cloud/storybook/design-systems-team/lodestar-core/mainline/sds-toast-ui/storybook/index.html
 */
const ToastActions = (0, _styled.default)("div")`
    display: inline-flex;
    align-items: center;
    margin: ${_spacing.sizes.xSmall}px ${_spacing.sizes.xSmall}px 0 0;
`;
exports.ToastActions = ToastActions;
//# sourceMappingURL=ToastActions.js.map